import {createSlice} from '@reduxjs/toolkit'
import { ROUTE_PATH } from '../../app/constants'

const initState = {
    header : "Company trademark",
    headerRenewal : "Company trademark",
    text : [
        "If your company operates under a federally registered trademark name (opens in a new window), enter it here. Continue to the next step if your company doesn't operate under a trademark."
    ],
    textRenewal : [
        "If your company operates under a federally registered trademark name (opens in a new window), review it here. Continue to the next step if your company doesn't operate under a trademark."
    ],
    navigation : {
        next : ROUTE_PATH.BUSINESS_CONTACT
    }
}

const companyTrademarkSlice = createSlice({
    name : "companyTrademark",
    initialState : initState,
    reducers : {
        setCompanyTrademarkText(state, action) { 
            state.tradeMark = action.payload
        }
    }
})

export const { setCompanyTrademarkText } = companyTrademarkSlice.actions

export default companyTrademarkSlice.reducer
